import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-24 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#d4edda' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-black mb-6"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Welcome to AGreenerSide
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            We're more than just a farm—we're a living classroom where influencers, educators, 
            and nature enthusiasts come to immerse themselves in the art of permaculture. 
            Study sustainable practices, explore our diverse ecosystems, and leave feeling 
            connected, educated, and inspired.
          </p>
        </div>

        <div className="bg-white/70 rounded-2xl overflow-hidden">
          <div className="w-full">
            <img 
              src="https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/8mh5wy0m_1000004308.jpg"
              alt="AGreenerSide at the farmers market - sharing our passion for sustainable growing"
              className="w-full h-[500px] object-cover"
            />
          </div>
          <div className="p-8 sm:p-12">
            <h3 
              className="text-3xl sm:text-4xl font-bold text-black mb-4"
              style={{ fontFamily: "'Crimson Text', serif" }}
            >
              Our Mission
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              At AGreenerSide, we're cultivating a sustainable future through hands-on education 
              and regenerative farming practices. Our mission is to inspire and equip individuals 
              with the knowledge and tools needed to create positive environmental impact.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Whether you're here to study permaculture principles, select sustainably grown 
              plants for your space, or simply reconnect with nature—you'll leave with practical 
              skills and a renewed sense of purpose.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
